import { render, staticRenderFns } from "./MyPurchases.vue?vue&type=template&id=113e0f08&scoped=true&"
import script from "./MyPurchases.vue?vue&type=script&lang=js&"
export * from "./MyPurchases.vue?vue&type=script&lang=js&"
import style0 from "./MyPurchases.vue?vue&type=style&index=0&id=113e0f08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113e0f08",
  null
  
)

export default component.exports